var _circle, _mask, _path, _circle2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "white",
    stroke: "url(#paint0_linear_2641_18936)",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2641_18936",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.071 15C24.5841 15 25.0045 14.5832 24.9569 14.0723C24.8 12.3886 24.2181 10.7668 23.259 9.3619C22.1248 7.70043 20.5159 6.41967 18.6424 5.68693C16.7689 4.9542 14.7179 4.80356 12.7574 5.2547C10.797 5.70583 9.01816 6.73776 7.65336 8.21569C6.28856 9.69361 5.40124 11.5488 5.10731 13.5389C4.81339 15.529 5.12652 17.5615 6.00581 19.3709C6.8851 21.1802 8.28966 22.6823 10.036 23.6809C11.5127 24.5253 13.1756 24.9765 14.8664 24.9991C15.3795 25.006 15.7616 24.5538 15.7208 24.0423V24.0423C15.68 23.5308 15.2314 23.1548 14.7187 23.1371C13.4016 23.0915 12.1104 22.7267 10.9583 22.068C9.53648 21.2549 8.3929 20.0319 7.67699 18.5587C6.96108 17.0856 6.70613 15.4307 6.94544 13.8104C7.18475 12.1901 7.9072 10.6796 9.01841 9.47625C10.1296 8.27294 11.5779 7.43275 13.1741 7.06544C14.7703 6.69812 16.4402 6.82077 17.9656 7.41736C19.491 8.01395 20.801 9.05673 21.7245 10.4095C22.4727 11.5055 22.939 12.7637 23.089 14.073C23.1474 14.5827 23.5579 15 24.071 15V15Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.071 15C24.5841 15 25.0045 14.5832 24.9569 14.0723C24.8 12.3886 24.2181 10.7668 23.259 9.3619C22.1248 7.70043 20.5159 6.41967 18.6424 5.68693C16.7689 4.9542 14.7179 4.80356 12.7574 5.2547C10.797 5.70583 9.01816 6.73776 7.65336 8.21569C6.28856 9.69361 5.40124 11.5488 5.10731 13.5389C4.81339 15.529 5.12652 17.5615 6.00581 19.3709C6.8851 21.1802 8.28966 22.6823 10.036 23.6809C11.5127 24.5253 13.1756 24.9765 14.8664 24.9991C15.3795 25.006 15.7616 24.5538 15.7208 24.0423V24.0423C15.68 23.5308 15.2314 23.1548 14.7187 23.1371C13.4016 23.0915 12.1104 22.7267 10.9583 22.068C9.53648 21.2549 8.3929 20.0319 7.67699 18.5587C6.96108 17.0856 6.70613 15.4307 6.94544 13.8104C7.18475 12.1901 7.9072 10.6796 9.01841 9.47625C10.1296 8.27294 11.5779 7.43275 13.1741 7.06544C14.7703 6.69812 16.4402 6.82077 17.9656 7.41736C19.491 8.01395 20.801 9.05673 21.7245 10.4095C22.4727 11.5055 22.939 12.7637 23.089 14.073C23.1474 14.5827 23.5579 15 24.071 15V15Z",
    fill: "white",
    stroke: "url(#paint1_linear_2641_18936)",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_2641_18936)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.1,
    cy: 2.1,
    r: 1.6,
    transform: "matrix(-1 0 0 1 22.2002 20)",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C12.5 22 13 22.5 15 23.5C16.4142 24.2071 16.765 23.8233 15 25C13.5 26 12 26 11 25.5",
    stroke: "url(#paint2_linear_2641_18936)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2641_18936",
    x1: 1.05132e-9,
    y1: 15.0242,
    x2: 30,
    y2: 14.9758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ABC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2641_18936",
    x1: 5,
    y1: 15.0161,
    x2: 25,
    y2: 14.9839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ABC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2641_18936",
    x1: 15.4401,
    y1: 23.1093,
    x2: 10.5,
    y2: 23.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A552"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.fac7a91f122ffe69f581a5699fcaeb47.svg";
export { ForwardRef as ReactComponent };